import React, { useState,useEffect } from 'react'
import Modal from 'components/modal'
import '../../../src/less/generate-scheduler-link-confirmation-modal.less'
import {getLanguageCodeAndCountryByLangCode} from '../../../src/shared/helpers/translations.js'
import Field from '../../components/controls/field'
const GenerateSchedulerLinkConfirmationModal = props => {
  const [confirmAvailabilities, setconfirmAvailabilities] = useState(false)
  const [confirmSetTranslations, setconfirmSetTranslations] = useState(false)
  const [confirmNoConferenceLink, setConfirmNoConferenceLink] = useState(false)
  const [missingMeetingInformationTranslations, setMissingMeetingInformationTranslations] = useState([])
  const [missingTopicLanguageTranslations, setMissingTopicLanguageTranslations] = useState([])


  var label = props.chosenTranslationsLabels;
  let topicNameDetails= props.topicNameDetails
  let meetingInformationMap= props.meetingInformationMap
  var detectedLanguages = label && label.split(",")
  const confirmAvaialbilities = (event) => {
    setconfirmAvailabilities(event)
  }
  const confirmTranslations = (event) => {
    setconfirmSetTranslations(event)
  }
  const getMissingLanguageTranslations = (topicNameDetails, meetingInformationMap) => {
    let missingTopicLanguageTranslations =[];
    meetingInformationMap.forEach((value, key) => {
      if (!topicNameDetails.has(key)) {
        let LangCode_langCountry=getLanguageCodeAndCountryByLangCode(key)
        missingTopicLanguageTranslations.push(LangCode_langCountry)
      }
    }
    )
    return missingTopicLanguageTranslations;
  }

  const getMissingMeetingInformationTranslations = (topicNameDetails, meetingInformationMap) => {
    let missingMeetingInformationTranslations = [];
    let isMeetingInformationOptional = false;
    let meetingValue = meetingInformationMap.get('en_us')
    if (meetingInformationMap.size == 1 && meetingValue.replace(/<[^>]+>/g, '').length == 0) {
      isMeetingInformationOptional = true
    }
    if (!isMeetingInformationOptional) {
      topicNameDetails.forEach((value, key) => {

        if (!meetingInformationMap.has(key)) {
          let LangCode_langCountry = getLanguageCodeAndCountryByLangCode(key)
          missingMeetingInformationTranslations.push(LangCode_langCountry)
        }
      }
      )
    }
    return missingMeetingInformationTranslations;
  }

  let isTopicTranslated=missingTopicLanguageTranslations.length ==0
  let isMeetingInformationTranslated=missingMeetingInformationTranslations.length ==0

  const getModalTitle = (isMeetingInformationTranslated, isTopicTranslated) => {
    if (!isMeetingInformationTranslated)
      return props.t('missing.meeting.information.translations');
    else if (!isTopicTranslated)
      return props.t('missing.topic.name.translations')
    else
      return props.t('generate.scheduler.link')
  }
  useEffect(() => {
    setMissingTopicLanguageTranslations(getMissingLanguageTranslations(topicNameDetails,meetingInformationMap))
    setMissingMeetingInformationTranslations(getMissingMeetingInformationTranslations(topicNameDetails,meetingInformationMap))
  }, [props.topicNameDetails,props.meetingInformationMap])

  return (
    <Modal
    
      title={getModalTitle(isMeetingInformationTranslated,isTopicTranslated)}
      isOpen={props.isOpen}
      className='generate-scheduler-link-confirmation-modal'
      type="modal"
      autoFocusSubmit={false}
      submitBtnText={isTopicTranslated ? props.t('generate.link') :props.t('ok')}
      onCancel={props.onClose}
      onSubmit={isTopicTranslated ? props.onSubmit :props.onClose}
      isSubmitting={props.isSubmitting}
      showSubmitBtn={props.displayError ? false : true}
      enableSubmit={ !isTopicTranslated ||(confirmAvailabilities && confirmSetTranslations && ((props.conferenceLink && props.conferenceLink.length > 0) || confirmNoConferenceLink))}
      cancelBtnText={props.displayError ? props.t('ok') : props.t('cancel')}
      showCancelBtn={isTopicTranslated ? true :false}
    > 
      {isMeetingInformationTranslated ?

        isTopicTranslated ?
          <>
            <div className="generate-scheduler-link-modal">
              <p>
                {props.t('generate.scheduler.link.before.generating')}

              </p>
              <div className="display-checkbox">
                <Field
                  type="checkbox"
                  isCheckBox="true"
                  label={props.t('scheduler.link.message.confirm.availability')}
                  onClick={(e) => { confirmAvaialbilities(e.target.checked) }}

                />
                <Field
                  type="checkbox"
                  isCheckBox="true"
                  label={detectedLanguages && detectedLanguages.length > 0 ? props.t('scheduler.link.message.confirm.translations') : props.t('no.meeting.information.required')}
                  onClick={(e) => { confirmTranslations(e.target.checked) }}

                />
                {(!props.conferenceLink || props.conferenceLink.length === 0) &&
                  <Field
                    type="checkbox"
                    isCheckBox="true"
                    label={props.t('scheduler.link.message.confirm.no.conference.link')}
                    onClick={(e) => { setConfirmNoConferenceLink(e.target.checked) }}
                  />
                }
              </div>
              {detectedLanguages && detectedLanguages.length > 0 &&
                <> <div class="detected-languages">
                  {props.t('generate.scheduler.link.detected')}
                </div>

                  <ul>
                    {detectedLanguages.map(x =>
                      <li key={x.id}>{x}</li>
                    )}

                  </ul>
                </>
              }
            </div>
          </>
          :
          <div className="generate-scheduler-link-modal">
            <p>
              {props.t('topic.name.must.be.translated')}

            </p>
            { !isTopicTranslated &&
              <> <div class="detected-languages">
                {props.t('needed.topic.name.translations')}
              </div>

                <ul>
                  {missingTopicLanguageTranslations.map(x =>
                    <li key={x.id}>{x}</li>
                  )}

                </ul>
              </>
            }
          </div>
        :
        <>
          <div className="generate-scheduler-link-modal">
            <p>
              {props.t('meeting.information.must.be.translated')}

            </p>
            { !isMeetingInformationTranslated &&
              <> <div class="detected-languages">
                {props.t('needed.meeting.information.translations')}
              </div>

                <ul>
                  {missingMeetingInformationTranslations.map(x =>
                    <li key={x.id}>{x}</li>
                  )}

                </ul>
              </>
            }
          </div>
        </>

   }
    </Modal>
  )
}

export default GenerateSchedulerLinkConfirmationModal
